/**
 * Resolve the global object (browser / worker).
 * @returns {typeof globalThis | undefined}
 */
export function getRoot() {
  if (typeof globalThis !== 'undefined') return globalThis;
  if (typeof window !== 'undefined') return window;
  if (typeof self !== 'undefined') return self;
  return undefined;
}

/**
 * Find the script element that loaded the core SDK.
 * Prefers document.currentScript; falls back to matching cst-prum IIFE filenames.
 * @returns {HTMLScriptElement | null}
 */
export function getSdkScriptElement() {
  if (typeof document === 'undefined') return null;

  if (document.currentScript && document.currentScript.src) {
    return document.currentScript;
  }

  const scripts = document.getElementsByTagName('script');
  for (let i = scripts.length - 1; i >= 0; i -= 1) {
    const src = scripts[i].src || '';
    if (/cst-prum(\.iife)?(\.full)?\.min\.js(\?.*)?$/i.test(src)) {
      return scripts[i];
    }
  }

  return null;
}

/**
 * Parse client id and CDN base directory from the core script URL.
 *
 * Expected shape:
 *   https://cdn.example.com/cst-prum.iife.min.js?client=cl-1
 *
 * @param {string} [scriptUrl]
 * @returns {{ clientId: string | null, baseUrl: string | null }}
 */
export function parseScriptUrl(scriptUrl) {
  if (!scriptUrl) {
    return { clientId: null, baseUrl: null };
  }

  let url;
  try {
    url = new URL(scriptUrl, typeof location !== 'undefined' ? location.href : undefined);
  } catch {
    return { clientId: null, baseUrl: null };
  }

  const clientId = url.searchParams.get('client');
  const basePath = url.pathname.replace(/[^/]+$/, '');
  const baseUrl = `${url.origin}${basePath}`;

  return {
    clientId: clientId ? String(clientId) : null,
    baseUrl,
  };
}

export const variable_constants = {
    "development": {
        RUM_ENDPOINT: 'https://collector-dev.thecommerceteam.com',
        RUM_RECORD_ENDPOINT: 'https://ingest-dev.thecommerceteam.com',
    },
    "production": {
        RUM_ENDPOINT: 'https://collector.thecommerceteam.com',
        RUM_RECORD_ENDPOINT: 'https://ingest.thecommerceteam.com',
    }
}

